import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TMachineListState } from './machine-list.models';

export const getMachineListState = (state: TMachineMaintenanceState) => state.machineListInfo;

export const getMachineListInfo = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.machineListingInfo,
);

export const getPagination = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.machineListingPagination,
);

export const getMachineListDropdown = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.machineListingFilterDropdown,
);

export const getBulkAssignLocationDropdown = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.bulkAssignLocationDropdown,
);

export const getSiblingFactoriesDropdown = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.siblingFactoriesDropdown,
);

export const getMachineTransferDropdown = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.machineTransferDropdown,
);

export const getMachineAndLineDetails = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.machineAndLineDetails,
);

export const getUserSelectedFilters = createSelector(
  getMachineListState,
  (state: TMachineListState) => state.machineListingInfo?.res.userSelectedFilters ?? [],
);

export const getListingTab = createSelector(getMachineListState, (state: TMachineListState) => state.currentListingTab);
